import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["socialNetworksUrls"];
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */

import { useEffect, useMemo, useRef, useState } from 'react';
import { Map as ImmutableMap } from 'immutable';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'edit... Remove this comment to see the full error message
import { calculateDiff } from 'editor-iframe-lib/redux/utils/iframeStateSync';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { padding } from 'UIComponents/styles/spacing';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import { BATTLESHIP, OLAF, PANTERA } from 'HubStyleTokens/colors';
import { selectAllLanguages, selectKnowledgeBase } from '../../../knowledge-base/selectors/knowledgeBaseDetails';
import TranslationLanguagesFilter from '../../../components/translationModal/TranslationLanguagesFilter';
import KnowledgeBaseTranslatedContentRecord from '../../../records/KnowledgeBaseTranslatedContentRecord';
import { updateKnowledgeBaseTranslations } from '../../../knowledge-base/actions/KnowledgeBaseActions';
import TranslateTemplateSideNav from './TranslateTemplateSideNav';
import { selectSyncedTranslations } from 'knowledge-content-ui/selectors/templateSettings';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import controller from '../../../utils/translatePreviewController';
import { PREVIEW_SYNC_CONFIG } from 'knowledge-content-ui/constants/TemplateEditorPreviewConstants';
import { getTranslateTemplatePreviewUrl } from '../../../utils/templatePreviewUtils';
import { selectTemplatePreviewStoreSlice } from '../../../selectors/templateSettings';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { useCurrentKnowledgeBaseId } from '../../../knowledge-base/hooks/knowledgeBaseHooks';
import { useAppDispatch, useAppSelector } from '../../../utils/hooks';
import ContentRoutes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledIframeWrapper = styled.div.withConfig({
  displayName: "TranslateTemplateModal__StyledIframeWrapper",
  componentId: "bycflu-0"
})(["height:100%;width:100%;overflow:hidden;position:relative;"]);
const StyledIframe = styled.iframe.withConfig({
  displayName: "TranslateTemplateModal__StyledIframe",
  componentId: "bycflu-1"
})(["height:100%;width:100%;border:0;@media screen and (max-width:1510px){transform:scale(0.7);transform-origin:0 0;width:calc(100% / 0.7);height:calc(100% / 0.7);overflow:auto;}"]);
function TranslateTemplatePreview(props) {
  const {
    indexTemplatePath,
    language,
    values
  } = props;
  const knowledgeBaseId = useCurrentKnowledgeBaseId();
  const baseStateSlice = useAppSelector(selectTemplatePreviewStoreSlice);
  const [iframeReady, setIframeReady] = useState(false);
  const lastSyncedStoreValue = useRef(null);
  const [previewIframeDomain, setPreviewDomain] = useState(window.hsPreviewDomain);
  const iframeSrc = getTranslateTemplatePreviewUrl(indexTemplatePath, language, knowledgeBaseId);
  useEffect(() => {
    if (!previewIframeDomain) {
      ContentRoutes.getPreviewDomainPromise().then(({
        previewDomain
      }) => {
        window.hsPreviewDomain = previewDomain;
        setPreviewDomain(previewDomain);
      });
    }
  }, [previewIframeDomain]);
  const pseudoStoreValue = useMemo(() => {
    return Object.assign({}, baseStateSlice, {
      homepageCategoriesSettings: null,
      templateSettings: baseStateSlice.templateSettings.update('knowledgeBaseSettings', settings => {
        const _values$toJS = values.toJS(),
          {
            socialNetworksUrls
          } = _values$toJS,
          jsValues = _objectWithoutPropertiesLoose(_values$toJS, _excluded);
        return settings.merge(Object.assign({}, jsValues, {
          socialNetworkUrls: socialNetworksUrls
        }));
      })
    });
  }, [baseStateSlice, values]);
  const iframeRef = useRef();
  useEffect(() => {
    const iframe = iframeRef.current;
    setIframeReady(false);
    controller
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    .start(iframe.contentWindow).catch(error => console.error('Error starting translate preview iframe communication.', error)).then(() => {
      lastSyncedStoreValue.current = null;
      setIframeReady(true);
    });
  }, [iframeSrc]);
  useEffect(() => {
    if (iframeReady) {
      const diff = calculateDiff(lastSyncedStoreValue.current, pseudoStoreValue, {
        config: PREVIEW_SYNC_CONFIG
      });
      controller.syncIframeState(diff);
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ homepageCategoriesSettings: null; template... Remove this comment to see the full error message
      lastSyncedStoreValue.current = pseudoStoreValue;
    }
  }, [iframeReady, pseudoStoreValue]);
  return /*#__PURE__*/_jsxs(StyledIframeWrapper, {
    children: [!iframeReady && /*#__PURE__*/_jsx(UILoadingOverlay, {
      contextual: true
    }), /*#__PURE__*/_jsx(StyledIframe, {
      ref: iframeRef,
      src: iframeSrc
    })]
  });
}
const SideNavContainer = styled.div.withConfig({
  displayName: "TranslateTemplateModal__SideNavContainer",
  componentId: "bycflu-2"
})(["flex:0 1 410px;border-right:1px solid ", ";"], BATTLESHIP);
const PreviewContainer = styled.div.withConfig({
  displayName: "TranslateTemplateModal__PreviewContainer",
  componentId: "bycflu-3"
})(["flex:1 1 870px;"]);
const FullBodyContainer = styled(UIFlex).attrs({
  align: 'stretch'
}).withConfig({
  displayName: "TranslateTemplateModal__FullBodyContainer",
  componentId: "bycflu-4"
})(["min-height:100%;"]);
const UnpaddedDialogBody = styled(UIDialogBody).withConfig({
  displayName: "TranslateTemplateModal__UnpaddedDialogBody",
  componentId: "bycflu-5"
})(["&&{", "}"], padding('all',
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
'0'));
const Header = styled(UIDialogHeader).withConfig({
  displayName: "TranslateTemplateModal__Header",
  componentId: "bycflu-6"
})(["&&{background-image:none;background-color:", ";color:", ";}border-bottom:1px solid ", ";"], OLAF, PANTERA, BATTLESHIP);
const EMPTY_TRANSLATED_CONTENT_RECORD = KnowledgeBaseTranslatedContentRecord.fromJS({});
export default function TemplateEditorTranslateModal(props) {
  const {
    articleLanguage,
    allLanguages,
    onClose
  } = props;
  const dispatch = useAppDispatch();
  const templateTranslations = useAppSelector(selectSyncedTranslations);
  const translatedContent = templateTranslations.get('data');
  const loaded = !!templateTranslations.get('lastLoaded');
  const knowledgeBase = useAppSelector(selectKnowledgeBase);
  const languages = useAppSelector(selectAllLanguages);
  const allKBLanguages = useMemo(() => [languages.primaryLanguage, ...languages.additionalLanguages], [languages]);
  const {
    indexTemplatePath
  } = knowledgeBase;
  const [draftTranslatedContent, setDraftTranslatedContent] = useState(translatedContent);
  useEffect(() => {
    setDraftTranslatedContent(translatedContent);
  }, [translatedContent]);
  const defaultPreviewLanguage = articleLanguage && articleLanguage || languages.primaryLanguage;
  const [previewLanguage, setPreviewLanguage] = useState(defaultPreviewLanguage);
  const [selectedLanguages, setSelectedLanguages] = useState(allLanguages);
  const [draftSelectedLanguages, setDraftSelectedLanguages] = useState(selectedLanguages);
  const applyDraftSelectedLanguages = () => setSelectedLanguages(draftSelectedLanguages);
  const languageFilterOptions = allKBLanguages.map(lang => {
    return {
      value: lang,
      forceEnabled: lang === languages.primaryLanguage
    };
  });
  const [publishRequestState, setPublishRequestState] = useState('IDLE');
  const addLanguageIfMissing = language => {
    return draftTranslatedContent.has(language) ? draftTranslatedContent : draftTranslatedContent.set(language, EMPTY_TRANSLATED_CONTENT_RECORD);
  };
  const onFieldChange = (language, fieldName, value) => {
    let newTranslatedContent = addLanguageIfMissing(language);
    newTranslatedContent = newTranslatedContent.setIn([language, fieldName], value);
    setDraftTranslatedContent(newTranslatedContent);
  };
  const onSocialLinksFieldChange = (language, networkType, uuid, value) => {
    let newTranslatedContent = addLanguageIfMissing(language);
    const newSocialLinkUrl = ImmutableMap({
      networkType,
      url: value,
      uuid
    });
    const indexToUpdate = newTranslatedContent.get(language).socialNetworksUrls.findIndex(socialNetwork => socialNetwork && socialNetwork.get('uuid') === uuid);
    if (indexToUpdate === -1) {
      newTranslatedContent = newTranslatedContent.updateIn([language, 'socialNetworksUrls'], socialNetworksUrls => socialNetworksUrls.push(newSocialLinkUrl));
    } else {
      newTranslatedContent = newTranslatedContent.setIn([language, 'socialNetworksUrls', indexToUpdate], newSocialLinkUrl);
    }
    setDraftTranslatedContent(newTranslatedContent);
  };
  const onFooterLinkFieldChange = (language, fieldName, indexToUpdate, uuid, {
    target: {
      name,
      value
    }
  }) => {
    let newTranslatedContent = addLanguageIfMissing(language);
    newTranslatedContent = newTranslatedContent.setIn([language, fieldName, indexToUpdate, name], value).setIn([language, fieldName, indexToUpdate, 'uuid'], uuid);
    setDraftTranslatedContent(newTranslatedContent);
  };
  const onPublish = () => {
    setPublishRequestState('REQUESTING');
    dispatch(updateKnowledgeBaseTranslations(draftTranslatedContent)).then(() => setPublishRequestState('SUCCEEDED'), () => setPublishRequestState('FAILED'));
  };
  const onPublishComplete = () => {
    onClose();
  };
  const dialogContent = loaded && draftTranslatedContent ? /*#__PURE__*/_jsx(UnpaddedDialogBody, {
    children: /*#__PURE__*/_jsxs(FullBodyContainer, {
      children: [/*#__PURE__*/_jsx(SideNavContainer, {
        children: /*#__PURE__*/_jsx(TranslateTemplateSideNav, {
          values: draftTranslatedContent,
          languages: selectedLanguages,
          onFieldChange: onFieldChange,
          onSocialLinksFieldChange: onSocialLinksFieldChange,
          onFooterLinkFieldChange: onFooterLinkFieldChange,
          previewLanguage: previewLanguage,
          onPreviewLanguageChange: setPreviewLanguage
        })
      }), /*#__PURE__*/_jsx(PreviewContainer, {
        children: /*#__PURE__*/_jsx(TranslateTemplatePreview, {
          indexTemplatePath: indexTemplatePath,
          language: previewLanguage,
          values: draftTranslatedContent.get(previewLanguage, EMPTY_TRANSLATED_CONTENT_RECORD)
        })
      })]
    })
  }) : /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    })
  });
  const hasNoLocalChanges = !translatedContent && !draftTranslatedContent || translatedContent && draftTranslatedContent && translatedContent.equals(draftTranslatedContent);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "fullscreen",
    "data-test-id": "translate-template-modal",
    children: [/*#__PURE__*/_jsx(Header, {
      children: /*#__PURE__*/_jsxs(UIToolBar, {
        className: "width-100",
        children: [/*#__PURE__*/_jsx(UIToolBarGroup, {
          children: /*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            children: [/*#__PURE__*/_jsx(UIButton, {
              onClick: onClose,
              use: "tertiary-light",
              className: "m-right-4",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.cancelButton"
              })
            }), /*#__PURE__*/_jsx(TranslationLanguagesFilter, {
              value: draftSelectedLanguages,
              articleLanguage: articleLanguage,
              options: languageFilterOptions,
              onChange: setDraftSelectedLanguages,
              onApply: applyDraftSelectedLanguages
            })]
          })
        }), /*#__PURE__*/_jsx(UIToolBarGroup, {}), /*#__PURE__*/_jsx(UIToolBarGroup, {
          children: /*#__PURE__*/_jsx(UILoadingButton, {
            disabled: !loaded || hasNoLocalChanges,
            failed: publishRequestState === 'FAILED',
            keepResultAfterFinish: true,
            loading: publishRequestState === 'REQUESTING',
            onClick: onPublish,
            onLoadingFinish: onPublishComplete,
            spinnerProps: {
              resultAnimationDuration: 1000
            },
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.templateEditor.translateModal.publishButton"
            })
          })
        })]
      })
    }), dialogContent]
  });
}